<template>
  <a class="mr-1 md:mr-2 cursor-pointer block relative tooltip-outer w-auto h-auto" v-if="!isBigger" :class="{ 'onreconation_icon': isRecognition, 'opacity-50': remainPoints < 1 || isDisabledInput }">
    <img src="@/assets/image/ai/mic_C.png" alt="" class="object-contain" v-if="!isRecording && isSupport && !isRecognition" @click="startRecord">
    <canvas id="canvas" ref="record" @click="stopRecord" v-if="isRecording && isSupport && !isRecognition"></canvas>
    <img src="@/assets/image/ai/mic_C_onreconation.png" alt="" class="object-contain" v-if="!isRecording && isSupport && isRecognition" @click="stopRecord">
    <img src="@/assets/image/ai/support.png" alt="" class="object-contain" v-if="!isSupport">
    <span class="tooltiptext">{{ $t('hover.record') }}</span>
  </a>
</template>

<script>
  import api from '@/api'
  import Recorder from 'js-audio-recorder'
  import { mapGetters } from 'vuex'
  import Bus from '@/components/bus.js'
  let recorder = new Recorder()
  export default {
    name: "SpeechRecognition",
    props: {
      isBigger: {
        type: Boolean,
        default: false
      },
      isDisabledInput: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {

        // 支援錄音
        isSupport: true,
        // 錄音中
        isRecording: false,
        // 辨識中
        isRecognition: false,

        // mediaRecorder: null,
        audioData: [],

        drawRecordId: null,

        count: 16,
        timer: null
      }
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ])
    },
    mounted () {
      Bus.$on('restartData', () => {
        console.log('restartData')
        if (this.isRecording) {
          this.onlyStopRecord()
        }
      })
    },
    destroy () {
      recorder.destroy().then(() => {
        recorder = null
      })
    },
    methods: {
      getPermission () {
        let self = this
        recorder.getPermission().then(() => {
          self.isSupport = true
        }, (error) => {
          self.isSupport = false
          console.log(error)
        })
      },

      startRecord () {
        let self = this

        if (self.remainPoints > 0 && !self.isDisabledInput) {
          let time = 0

          recorder.start().then(() => {
            self.countDown()
            self.isRecording = true
            self.drawRecord()
          }, (error) => {
            console.log(error)
            self.isRecording = false
          })

          recorder.onprogress = (params) => {
            if (params.vol <= 10) {
              time++
            } else {
              time = 0
            }

            if (time >= 35) {
              self.stopRecord()
            }
          }
          Bus.$emit('stopPlay')

        }

        if (self.remainPoints < 1) {
          self.swal_failPopPoints('點數不足')
        }
      },

      stopRecord () {
        let self = this

        recorder.stop()
        self.isRecording = false

        self.audioData = recorder.getWAVBlob()

        self.getSTT(recorder.getWAVBlob())

        clearInterval(self.timer)
        self.$emit('speechCountDown', { isSpeechRecognition: false, count: 16 })
        self.count = 16
      },
      onlyStopRecord () {
        let self = this

        recorder.stop()
        self.isRecording = false

        clearInterval(self.timer)
        self.$emit('speechCountDown', { isSpeechRecognition: false, count: 16 })
        self.count = 16
      },

      getSTT (audioData) {
        let self = this

        let path = `/ai/stt`
        if (self.$route.name === 'ChatAIJp') {
          path = path + `/?lang=ja-JP`
        }

        let formData = new FormData()
        formData.append('file', audioData)

        self.isRecognition = true

        api.post(path, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          })
          .then((response) => {
            self.$emit('emitSpeechRecognition', response.data)

            self.isRecognition = false

            self.$data.isRecording = self.$options.data().isRecording
            self.$data.isRecognition = self.$options.data().isRecognition
            self.$data.audioData = self.$options.data().audioData
            self.$data.drawRecordId = self.$options.data().drawRecordId
            self.$data.timer = self.$options.data().timer
          })
          .catch(() => {
            self.$data.isRecording = self.$options.data().isRecording
            self.$data.isRecognition = self.$options.data().isRecognition
            self.$data.audioData = self.$options.data().audioData
            self.$data.drawRecordId = self.$options.data().drawRecordId
            self.$data.timer = self.$options.data().timer
            self.$swal({
              html: `<p>請重新操作錄音</p>`,
              showDenyButton: false,
              focusConfirm: false,
              confirmButtonText: `我知道了`,
              title: 'Notice',
              customClass: {
                title: 'text-white',
                container: '',
                popup: 'p-0',
                header: 'swal-header-notice justify-center items-center',
                closeButton: '',
                htmlContainer: 'remainPoints_swal my-4',
                actions: 'mb-4 mt-2',
                confirmButton: 'btn-submit',
                cancelButton: 'bg-red-main-ai',
              }
            })
          })
      },

      drawRecord () {
        let self = this

        self.drawRecordId = requestAnimationFrame(self.drawRecord)
        self.drawWave({
          canvas: self.$refs.record,
          dataArray: recorder.getRecordAnalyseData(),
          bgcolor: 'rgb(200, 200, 200, 0)',
          lineWidth: 1,
          lineColor: 'rgb(255, 255, 255)'
        })
      },

      drawWave({
        canvas,
        dataArray,
        bgcolor = 'rgb(200, 200, 200, 0)',
        lineWidth = 2,
        lineColor = 'rgb(0, 0, 0)'
      }) {
        if (!canvas) return
        canvas.width = 54;
        canvas.height = 54;

        let background = new Image()
        background.src = require('@/assets/image/ai/mic_C_onrecord.png')

        const ctx = canvas.getContext('2d')
        const bufferLength = dataArray.length
        const sliceWidth = canvas.width / bufferLength
        let x = 0
        ctx.drawImage(background, 0, 0)
        ctx.fillStyle = bgcolor
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        ctx.lineWidth = lineWidth
        ctx.strokeStyle = lineColor

        ctx.beginPath()

        for (let i = 0; i < bufferLength; i++) {
          const v = dataArray[i] / 128
          const y = (v * canvas.height) / 2

          if (i === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
          x += sliceWidth
        }

        ctx.lineTo(canvas.width, canvas.height / 2)
        ctx.stroke()
      },

      countDown () {
        let self = this
        self.timer = setInterval(() => {
            self.count--
            self.$emit('speechCountDown', { isSpeechRecognition: true, count: self.count })

            if (self.count === -1) {
              self.stopRecord()
              clearInterval(self.timer)
              self.count = 16
              self.$emit('speechCountDown', { isSpeechRecognition: false, count: 16 })
            }
          }, 1000
        )
      },

      swal_failPopPoints (text) {
        let self = this
        let defaultTitle = text ?  `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
        self.$swal.fire({
          html: defaultTitle,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: `確認`,
          title: 'Notice',
          customClass: {
            title: 'text-white',
            container: '',
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            closeButton: '',
            htmlContainer: 'save_check my-4 text-xl',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            cancelButton: 'bg-red-main-ai',
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .microphone-btn {
    background-color: #5A5D9B;
    padding: .8rem 6.5rem;
    border-radius: 53px;
    img {
      height: 26px;
      width: auto;
    }
  }
  .onreconation_icon {
    &:after {
      position: absolute;
      content: '';
      background-image: url('~@/assets/image/ai/mic_loading.png');
      background-position: center;
      background-size: contain;
      width: 38px;
      height: 38px;
      z-index: 2;
      left: 15%;
      top: 15%;
      transform: translate(-50%, -50%);
      animation: move 2s linear infinite;
      transform-origin: center;
      display: block;
    }
  }
  @keyframes move {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>